<div id="sub-nav-options">
  <menu>
    <li class="text-color-gray-9" *ngFor="let option of options">
      <button
        class="test option centered-vert pl-7px"
        *ngIf="(option.showOptionCondition$ | async) || !option.showOptionCondition$"
        [ngClass]="{ active: isActive(option) }"
        [attr.data-test-id]="'sub-nav-tab'"
        (click)="view(option)"
        tabindex="0">
        <i class="mr-4px" *ngIf="option.icon" [uiType]="option.icon" ui-icon></i>
        <p class="fs-13px mb-0px fw-500 hov-cursor-p ellipsis">{{ option.label | localize }}</p>
      </button>
    </li>
  </menu>
</div>
